import { h } from 'preact';
import { useState } from 'preact/hooks';
import { route } from 'preact-router';

interface NavLink {
  label: string;
  path: string;
  icon: string;
}

interface MobileMenuProps {
  links: NavLink[];
  userStatus: string;
  onLogout: () => void;
  currentPath: string;
}

export default function MobileMenu({ links, userStatus, onLogout, currentPath }: MobileMenuProps) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleNavigation = (path: string) => {
    route(path);
    setIsOpen(false);
  };

  return (
    <div class="md:hidden">
      {/* Hamburger Button */}
      <button
        onClick={toggleMenu}
        class="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-orange-500"
        aria-expanded={isOpen}
        aria-label="Menú principal"
      >
        {isOpen ? (
          // Close Icon
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          // Hamburger Icon
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        )}
      </button>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div class="fixed inset-0 z-40 bg-black bg-opacity-50" onClick={() => setIsOpen(false)} />
      )}

      {/* Mobile Menu Panel */}
      <div
        class={`fixed top-0 right-0 z-50 h-full w-64 bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div class="flex flex-col h-full">
          {/* Header */}
          <div class="flex items-center justify-between px-4 py-5 border-b border-gray-200">
            <span class="text-lg font-semibold text-gray-900">Menú</span>
            <button
              onClick={() => setIsOpen(false)}
              class="p-2 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100"
              aria-label="Cerrar menú"
            >
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* User Info */}
          <div class="px-4 py-4 border-b border-gray-200 bg-gray-50 flex items-center space-x-3">
            <svg class="w-6 h-6 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <p class="text-sm font-medium text-gray-700 capitalize">{userStatus.replace(/_/g, ' ')}</p>
          </div>

          {/* Navigation Links */}
          <nav class="flex-1 px-2 py-4 space-y-1 overflow-y-auto">
            {links.map((link) => (
              <button
                key={link.path}
                onClick={() => handleNavigation(link.path)}
                class={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                  currentPath === link.path
                    ? 'bg-orange-100 text-orange-900'
                    : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                }`}
              >
                <span class="mr-3 text-lg">{link.icon}</span>
                {link.label}
              </button>
            ))}
          </nav>

          {/* Logout Button */}
          <div class="px-4 py-4 border-t border-gray-200">
            <button
              onClick={() => {
                onLogout();
                setIsOpen(false);
              }}
              class="w-full flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors"
            >
              <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
